import { Skeleton } from 'antd';
import API from 'API';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import "./index.css"

export default function ShowWeddingWishList() {
    const [wishes, setWishes] = useState([]);
    const [getting, setGetting] = useState(false);
    const containerRef = useRef(null);
    const pageRef = useRef(1);
    const maxNumRef = useRef(null);
    const gettingRef = useRef(false);
    const debounceTimeoutRef = useRef(null);
    const abortControllerRef = useRef(null);
    const mountedRef = useRef(false);

    const getData = useCallback(() => {
        if (gettingRef.current) {
            return;
        }

        if (maxNumRef.current !== null && maxNumRef.current <= (pageRef.current - 1) * 10) {
            return;
        }

        const controller = new AbortController();

        gettingRef.current = true;
        abortControllerRef.current = controller;
        if (mountedRef.current) {
            setGetting(true);
        }

        API.get("/get-wedding-wishes/", {
            params: { page: pageRef.current },
            signal: controller.signal,
        })
        .then(res => {
            setWishes(wishes => [...wishes, ...res.data.results]);
            maxNumRef.current = res.data.count;
            pageRef.current += 1;
        })
        .catch(error => {
            if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError") {
                return;
            }
            console.log(error);
        })
        .finally(() => {
            gettingRef.current = false;

            if (abortControllerRef.current === controller) {
                abortControllerRef.current = null;
            }

            if (mountedRef.current) {
                setGetting(false);
            }
        })
    }, [])

    const handleScroll = useCallback(() => {
        const el = containerRef.current;
        if (!el || gettingRef.current) return;

        const isBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 5;

        if (!isBottom) {
            return;
        }

        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            debounceTimeoutRef.current = null;
            getData();
        }, 150);
    }, [getData]);

    useEffect(() => {
        const el = containerRef.current;
        if (!el) return;

        el.addEventListener("scroll", handleScroll);
        return () => el.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);

    useEffect(() => {
        mountedRef.current = true;
        getData();

        return () => {
            mountedRef.current = false;

            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }

            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, [getData]);

    return <div 
        ref={containerRef}
        className='show-wedding-wish-list'
    >
        {wishes.map((item, index) => (
            <div key={index} className='show-wedding-wish-list-message-item'>
                <div className='show-wedding-wish-list-author'
                    style={{
                        // fontFamily: "'Gowum Dodum',san-serif"
                    }}>{item.name}</div>
                <div className='show-wedding-wish-list-message'>{item.message}</div>
            </div>
        ))}
        {getting && <Skeleton active paragraph={{
            rows: 1
        }}/>}
    </div>
}
